import { memo, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { paths } from '@/shared/config/paths';
import { useAuthStore } from '@/store/useAuthStore';
import { useReceptionMode } from '@/features/reception';
import PageLoadingSkeleton from '@/shared/components/layout/PageLoadingSkeleton';

// 리셉션 모드가 활성 상태인 동안에는 현장 체크인 콘솔 밖의 라우트 접근을 차단
// (뒤로가기·새로고침으로 스캔 모드를 우회해 일반 관리자 화면으로 빠져나가는 것을 방지)
// reception 상태는 localStorage에 저장되지 않으므로, 진입 시 서버(Redis) 상태로 동기화 후 판단
const ReceptionLockGuard = () => {
	const { isAuthenticated, reception } = useAuthStore();
	const { syncStatus } = useReceptionMode();
	const [isChecking, setIsChecking] = useState(true);

	useEffect(() => {
		if (!isAuthenticated) {
			setIsChecking(false);
			return;
		}
		syncStatus().finally(() => setIsChecking(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAuthenticated]);

	if (isAuthenticated && isChecking) {
		return <PageLoadingSkeleton />;
	}
	if (reception.active) {
		return <Navigate to={paths.onsiteCheckIn.scan.path} replace />;
	}
	return <Outlet />;
};

export default memo(ReceptionLockGuard);
